import { mapGetters } from 'vuex';

export default {
  name: 'SuccessRegister',
  computed: {
    ...mapGetters({
      agentCode: 'auth/agentCode'
    })
  },
  created() {}
};
